export const getSingleValue = (
  value: string | string[] | undefined
): string | undefined => {
  if (!value) return undefined;
  if (typeof value === "string") return value.trim() || undefined;
  if (Array.isArray(value) && value.length === 1) return value[0];
  return undefined;
};

export const hasMultipleValues = (
  value: string | string[] | undefined
): boolean => {
  if (!value) return false;
  if (typeof value === "string") return false;
  if (Array.isArray(value) && value.length > 1) return true;
  return false;
};

export const hasNoValues = (
  value: string | string[] | undefined
): boolean => {
  if (!value) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return true;
};
